"use client";

import { useCallback, useTransition } from "react";
import { useQueryParamsAdapter } from "./queryParamsAdapter";

export function useQueryParamsNavigate() {
  const { searchParams, pushQuery, isPending: adapterPending } = useQueryParamsAdapter();
  const [isPending, startTransition] = useTransition();

  const navigate = useCallback(
    (updater: (params: URLSearchParams) => void) => {
      if (typeof window === "undefined") return;
      const params = new URLSearchParams(searchParams.toString());
      updater(params);

      startTransition(() => {
        pushQuery(params.toString());
      });
    },
    [searchParams, pushQuery],
  );

  return { navigate, isPending: isPending || adapterPending };
}

